// Light or dark UI, chosen in the sidebar. 'system' leaves it to daisyUI's
// --prefersdark (app/assets/css/main.css). The cards are drawn in fixed
// colours, so this never reaches the PDF.
export type ThemeChoice = 'system' | 'light' | 'dark'

const daisyThemes = { light: 'cupcake', dark: 'business' } as const
const storageKey = 'witness-card.theme'

function storedChoice(): ThemeChoice {
  const stored = localStorage.getItem(storageKey)
  return stored === 'light' || stored === 'dark' ? stored : 'system'
}

export function applyTheme(choice: ThemeChoice) {
  if (choice === 'system') {
    document.documentElement.removeAttribute('data-theme')
  }
  else {
    document.documentElement.setAttribute('data-theme', daisyThemes[choice])
  }
}

export function useTheme() {
  const choice = useState<ThemeChoice>('theme', storedChoice)

  function setTheme(newChoice: ThemeChoice) {
    choice.value = newChoice
    if (newChoice === 'system') {
      localStorage.removeItem(storageKey)
    }
    else {
      localStorage.setItem(storageKey, newChoice)
    }
    applyTheme(newChoice)
  }

  return { choice, setTheme }
}
